export const email = state => state.AuthReducer.email
export const password = state => state.AuthReducer.password
export const token = state => state.AuthReducer.token
export const expires_in = state => state.AuthReducer.expires_in
export const auth = state => state.AuthReducer.auth
export const user = state => state.AuthReducer.user